import React, { CSSProperties } from "react";
import Checkbox from "common/Checkbox/Checkbox";
import styled from "styled-components";

interface TableCheckboxProps {
  checked?: boolean;
  indeterminate?: boolean;
  disabled?: boolean;
  onClick: () => void;
  style?: CSSProperties;
  testId?: string;
}

const TableCheckbox = ({
  checked,
  indeterminate,
  disabled,
  onClick,
  style,
  testId,
}: TableCheckboxProps) => {
  return (
    <CheckboxWrapper
      data-testid={testId}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      $disabled={disabled}
      style={style}
    >
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Checkbox
          checked={checked}
          indeterminate={indeterminate}
          onChange={(e) => {
            e.stopPropagation();
            onClick();
          }}
        />
      </div>
    </CheckboxWrapper>
  );
};

export default TableCheckbox;

const CheckboxWrapper = styled.div<{ $disabled?: boolean }>`
  cursor: pointer;
  width: 50px;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(p) =>
    p.$disabled &&
    `
    opacity: ${p.theme.isDarkMode ? 0.3 : 0.5};
  `}
`;
